import type { JointGroupsSlice, JointGroupsState, ViewerSliceCreator } from "./types";

export const jointGroupsInitialState: JointGroupsState = {
  jointGroups: [],
  suggestedGroups: [],
  showSuggestedGroupsModal: false,
  selectedGroupFilter: null,
};

export const createJointGroupsSlice: ViewerSliceCreator<JointGroupsSlice> = (set) => ({
  ...jointGroupsInitialState,

  setJointGroups: (msg) =>
    set((state) => {
      state.jointGroups = msg.groups;
    }),

  setSuggestedGroups: (msg) =>
    set((state) => {
      state.suggestedGroups = msg.suggestions;
      // Auto-show modal if there are suggestions
      if (msg.suggestions.length > 0) {
        state.showSuggestedGroupsModal = true;
      }
    }),

  setShowSuggestedGroupsModal: (show) =>
    set((state) => {
      state.showSuggestedGroupsModal = show;
    }),

  setSelectedGroupFilter: (groupName) =>
    set((state) => {
      state.selectedGroupFilter = groupName;
    }),
});
